export default {
	name  : "statistics_parking",
	props : [
		"info_to_component",
		"ref_to_component",
		"layout_id",
		"layout",
	],
	data : (vm) => ({
		info 			: {	
			devices : []
		},
		heads 			: {
			title 	: vm.$ml.get('statistics'), 
			title1 	: vm.$ml.get("parking"), 
			title2 	: "", 

			icon 	: "mdi-chart-bar-stacked"
		},
		show 			: {
			search 		: false,
			close 		: true,
			list_fields : false,
			table 		: false,
		},
		list_show 		: [],
		ref 			: "",
		ID_notification : "",
		action_comp 	: {},
		info_counters   : {},
		headers 		: [
			{ text : "", value : "name" },			
			{ text : vm.$ml.get("parked"), value : "parked" },
			{ text : vm.$ml.get("overpaid_parking"), value : "overpaid_parking" },
			{ text : vm.$ml.get("processed_entries"), value : "processed_entries" },
			{ text : vm.$ml.get("total"), value : "total" },
		],
		loading 		: false,
		total 			: 0,
		height_table 	: 300,
		list_counters 	: {},
		list_fields 	: [
			{
				multiple 	: false,
				type 		: "select",
				key 		: "type",
				list 		: ["entry", "exit"],
				text 		: vm.$ml.get("type"),
				cols 		: 6,
			},
			{
				multiple 	: true,
				type 		: "select",
				key 		: "devices",
				list 		: vm.$store.getters["Devices/list"],
				text 		: vm.$ml.get("devices"),
				item_text  	: "name", 
				cols 		: 6,
			},
			{
				
				type 		: "btn",
				key 		: "btn",
				color 		: "primary",
				action 		: "confirm_options",
				text 		: vm.$ml.get("confirm"),
				cols 		: 6,
			},
		],
		ID_notification 	: "statistics_parking", 
		bus 				: {},
		bus_name  			: "",
	}), // data

	created(){
		if (this.info_to_component) {
			this.render_info(this.info_to_component);
		}
		if (this.layout_id) {
			this.ID_notification += "_" + this.layout_id;
		}
		if (this.$route && this.$route.name.includes("dashboard")) {
    		let modul = this.$store.getters["auth/permission"]("dashboard");    		
    		if (!modul.can_edit) {
    			this.show.close 		= false
    		}
    	}
	},
	
	computed :{

	}, // computed

	methods : {
		actions(act, item, opt){
			if (act == "close_component") {
				this.$emit('close_component', this.layout_id);
			}else
			if (act == "confirm_options") {
				this.show.table 		= true;
				this.show.list_fields 	= false;
				if (this.info && this.info.type == "exit") {
					this.heads.title2 = this.$ml.get("exit");
					this.headers = [
						{ text : "", value : "name" },			
						{ text : this.$ml.get("paid"), value : "paid" },
						{ text : this.$ml.get("unpaid"), value : "unpaid" },
						{ text : this.$ml.get("paid_by_post"), value : "paid_by_post" },
						{ text : this.$ml.get("whitelist"), value : "whitelist" },
						{ text : this.$ml.get("others"), value : "others" },						
						{ text : this.$ml.get("total"), value : "total" },
					];
				}else{
					this.heads.title2 = this.$ml.get("entry");					
				}
				if (this.info && this.info.devices && this.info.devices.length > 0) {
					this.total = this.info.devices.length;
					this.info.devices.forEach((dev)=>{
						if (dev && dev.deviceId) {
							this.list_counters[dev.deviceId] = {
								name : dev.name,
							};
							if (this.info && this.info.type == "exit") {
								this.list_counters[dev.deviceId].paid 			= 0;
								this.list_counters[dev.deviceId].unpaid 		= 0;
								this.list_counters[dev.deviceId].paid_by_post 	= 0;
								this.list_counters[dev.deviceId].whitelist 		= 0;
								this.list_counters[dev.deviceId].others 		= 0;
								this.list_counters[dev.deviceId].total 			= 0;
							}else{
								this.list_counters[dev.deviceId].parked 			= 0;
								this.list_counters[dev.deviceId].overpaid_parking 	= 0;
								this.list_counters[dev.deviceId].processed_entries 	= 0;
								this.list_counters[dev.deviceId].total 				= 0;
							}
						}
					})

				}else{
					this.total = 0;
				}
				if (opt != "no_emit") {

					this.$emit("update_of_component", {
						component 	: "statistics_parking",
						value 		: { ...this.info },
						ID 			: this.layout_id,
					});
				}
				this.get_statistics();
				this.render_bus();
			}
		}, // actions

		render_info(item){
			if (item && !Array.isArray(item)) {
				this.info = { ...item };
				this.actions("confirm_options", null, "no_emit");
			}else{
				this.show.list_fields = true;
			}
		}, // render info

		render_bus(){
			if (this.bus_name) {
				this.$EventBus.$off(this.bus_name, this.bus[this.bus_name]);
				this.bus_name = "";
			}
			this.bus_name = "events_parking_counter";
			this.$EventBus.$on(this.bus_name, this.bus[this.bus_name] = (action)=>{
				if (action && action.length > 0) {
					action.forEach((dev)=>{
						if (dev && this.info && dev.type == this.info.type && dev.statistics) {							
							this.list_counters[dev.device_id] = { ...this.list_counters[dev.device_id], ...dev.statistics }
						}
					})
				}
			});	
		}, // render bus

		get_statistics(){
			if (this.info) {
				const api 	= this.$URL + "/api/v1/register_event_parking/stats";
				let devices = []; 
				let datess 	= this.$Format.format_date_time(null, null, true, false);
				if (this.info.devices && this.info.devices.length > 0) {
					this.info.devices.forEach((dev) => { if (dev) {devices.push(dev.deviceId)} });
				}
				let info_up = {
					start 		: datess.start,
					end 		: datess.end,
					type 		: this.info.type,
					timeZone 	: this.$timezone,	
					deviceId 	:  devices,
				};
				this.$axios.post(api,info_up).then(res => {
					if (res && res.data && res.data.rows) {
						res.data.rows.forEach((row)=>{
							if (row && this.info && row.type == this.info.type && row.statistics) {
								this.list_counters[row.device_id] = { ...this.list_counters[row.device_id], ...row.statistics }
							}
						})
					}	
				}).catch(er => { console.warn("Error get statistics parking ", er)});
			}else{
				console.warn("Required info ", this.info);
			}
		}, // get statistics

	}, // methods	
	
	
	mounted(){

	}, // mounted

	beforeDestroy(){
		this.$Helper.clear_bus(this.$EventBus, this.bus, this.ID_notification);
	}, // before destroy
}; // export default